<div class="position-relative h-100">
    <div class="modal-header">
        <h4 class="modal-title pull-left" translate>Add reminder</h4>
        <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
            <sb-inline-svg class="icon icon-close" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
            </sb-inline-svg>
        </button>
    </div>
    <div class="modal-body text-center">
        <form class="elements-container" #modalForm="ngForm" [ngClass]="{ submitted: isSubmitted }">
            <div class="input-group align-items-center">
                <input
                    type="text"
                    name="dateField"
                    bsDatepicker
                    class="form-control"
                    placement="top"
                    autocomplete="off"
                    container="body"
                    appFocus
                    [placeholder]="'dd.mm.yyyy' | translate"
                    [ngClass]="{ 'ng-invalid': isSubmitted && (dateField.invalid || !date) }"
                    #dp="bsDatepicker"
                    [ngModelOptions]="{ standalone: true }"
                    #dateField
                    [(ngModel)]="date"
                    (ngModelChange)="updateDate()"
                    [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false, adaptivePosition: true }"
                    [minDate]="todayDate" />
                <div class="input-group-append">
                    <button
                        type="button"
                        class="btn btn-calender btn-icon"
                        aria-label="Calender picker"
                        [ngClass]="{ 'ng-invalid': dateField.invalid || !date, active: dp.isOpen }"
                        (click)="dp.toggle()"
                        tabindex="-1"
                        [attr.aria-expanded]="dp.isOpen">
                        <sb-inline-svg class="icon" [url]="'sb-tools/theme/images/calendar-icon.svg'"></sb-inline-svg>
                    </button>
                </div>
                <timepicker
                    #timeField
                    [showMeridian]="false"
                    name="timeField"
                    ngDefaultControl
                    class="ms-3 time-control"
                    (isValid)="isTimeValid = $event"
                    [ngClass]="{
                        'ng-invalid': isSubmitted && !isTimeValid && (!timeField.hours || !timeField.minutes),
                    }"
                    (ngModelChange)="updateTime($event)"
                    [(ngModel)]="time"
                    required>
                </timepicker>
            </div>
            @if (isSubmitted && !date && !time) {
                <div class="text-danger text-start" translate>Please fill this field</div>
            }

            @if (isSubmitted && !date && time) {
                <div class="text-danger text-start" translate>Please choose date</div>
            }

            @if (isSubmitted && date && !time) {
                <div class="text-danger text-start" translate>Please choose time</div>
            }

            @if (dateTime < todayDate) {
                <div class="text-danger text-start" translate>Please choose time in the future</div>
            }

            @if (hasReopenOption) {
                <div class="form-control-container text-start mt-3">
                    <label class="checkbox__label checkbox__label--margin-bottom-15px">
                        {{ 'Open after reminder ended' | translate }}
                        <input type="checkbox" [(ngModel)]="isReopenTicket" name="isReopenTicket" />
                        <span class="checkbox__checkmark"></span>
                    </label>
                </div>
            }
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
        <button [disabled]="isSending" type="button" class="btn btn-primary" (click)="confirm()" translate>Save</button>
    </div>
</div>
